import { createContext, useContext, useState } from "react";
import ModalFormulario from "../components/Modal";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [onConfirm, setOnConfirm] = useState(null);
    const [typeDemo, setTypeDemo] = useState('');

    const openModal = (callBack, tipoDemo) => {
        setOnConfirm(() => callBack);
        setIsOpen(true);
        setTypeDemo(tipoDemo);
    }

    const closeModal = () =>{
        setIsOpen(false);
        setOnConfirm(null);
    }

    return (
        <ModalContext.Provider value={{ openModal, closeModal, onConfirm, typeDemo }}>
            {children}
            {isOpen && (
                <ModalFormulario />
            )}
        </ModalContext.Provider>
    )
}

export const useGlobalModal = () => useContext(ModalContext);